import { ComposerPrimitive, useAui } from '@assistant-ui/react';
import { useState } from 'react';

import { controlChromeVariants } from '@playbooks/ui/components/component-recipes';
import { cn } from '@playbooks/ui/lib/utils';

import { ComposerFooter } from 'components/composer/composer-footer';
import { ComposerMessage } from 'components/composer/composer-message';
import { ComposerVoice } from 'components/composer/composer-voice';
import { useToast } from 'contexts';

const ComposerFlow = ({
	type = 'app',
	disabled = false,
	canManagePreferences = false,
	canManageProjectDefaults = false,
	rootApi = undefined,
	model,
	modelDisabled = false,
	onModelSelect,
	onPreferencesChange = undefined,
	preferences = undefined,
	connectors = [],
	onDraftPreferencesChange = undefined,
	onDraftConnectorsChange = undefined,
	onPlanModeChange = undefined,
	deliveryMode = 'queue',
	onDeliveryModeChange = undefined,
	modeDisabled = false,
	placeholder = 'What would you like to build?',
	planMode = false,
	showFocusRing = true,
}) => {
	const aui = useAui();
	const [view, setView] = useState('message');
	const toast = useToast();

	const onVoiceCancel = () => setView('message');
	const onVoiceError = e => {
		toast.showError(e);
		setView('message');
	};
	const onVoiceStart = () => setView('voice');
	const onVoiceTranscript = transcript => {
		const current = aui.composer().getState().text || '';
		const next = [current, transcript].filter(Boolean).join(current ? '\n' : '');
		aui.composer().setText(next);
	};
	return (
		<section
			className={cn(
				controlChromeVariants(),
				'overflow-hidden rounded-media focus-visible:border-border-strong focus-visible:ring-0',
				showFocusRing && 'focus-within:border-focus focus-within:ring-3 focus-within:ring-focus/50',
			)}>
			{view === 'message' && (
				<ComposerPrimitive.AttachmentDropzone
					disabled={disabled}
					className='relative data-[dragging=true]:before:pointer-events-none data-[dragging=true]:before:absolute data-[dragging=true]:before:inset-1 data-[dragging=true]:before:z-10 data-[dragging=true]:before:rounded-panel data-[dragging=true]:before:border data-[dragging=true]:before:border-dashed data-[dragging=true]:before:border-foreground-nav data-[dragging=true]:before:bg-surface-hover data-[dragging=true]:before:content-[""]'>
					<ComposerMessage disabled={disabled} placeholder={placeholder} />
					<ComposerFooter
						disabled={disabled}
						canManagePreferences={canManagePreferences}
						canManageProjectDefaults={canManageProjectDefaults}
						rootApi={rootApi}
						model={model}
						modelDisabled={modelDisabled}
						deliveryMode={deliveryMode}
						onDeliveryModeChange={onDeliveryModeChange}
						modeDisabled={modeDisabled}
						onModelSelect={onModelSelect}
						onPreferencesChange={onPreferencesChange}
						preferences={preferences}
						connectors={connectors}
						onDraftPreferencesChange={onDraftPreferencesChange}
						onDraftConnectorsChange={onDraftConnectorsChange}
						planMode={planMode}
						onPlanModeChange={onPlanModeChange}
						type={type}
						onVoiceStart={onVoiceStart}
					/>
				</ComposerPrimitive.AttachmentDropzone>
			)}
			{view === 'voice' && (
				<ComposerVoice
					onCancel={onVoiceCancel}
					onComplete={onVoiceCancel}
					onError={onVoiceError}
					onTranscript={onVoiceTranscript}
				/>
			)}
		</section>
	);
};

export { ComposerFlow };
